// extracted by mini-css-extract-plugin
export default {"label":"Label_label__mt1IT","labelGreen100":"Label_labelGreen100__rIFIF","labelGreen10":"Label_labelGreen10__K5FO2","labelWhite":"Label_labelWhite__EkJF9"};